import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../../utils/index";
import Form from "react-bootstrap/Form";
import { useAuthHeaders } from "../../../../components/Token";
import Swal from "sweetalert2/dist/sweetalert2.js";

function EditSubCategory() {
  const { _id } = useParams();
  const [newSubCategoryName, setNewSubCategoryName] = useState("");
  const navigate = useNavigate();
  const [categories, setCategories] = useState("");
  const headers = useAuthHeaders();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/subcategory/admin/singlesubcategory/${_id}`, {
        headers,
      })
      .then((response) => {
        setNewSubCategoryName(response.data?.subcategory?.name);
        setCategories(response.data?.subcategory?.category?.name);
        console.log("response in singlesubcategory", response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);



  const handleSave = (e) => {
    e.preventDefault();
    const data = { name: newSubCategoryName };
    axios
      .put(`${API_BASE_URL}/subcategory/admin/updatesubcategory/${_id}`, data, {
        headers,
      })
      .then((response) => {
        navigate("/subCategory");
      })
      .catch((error) => {
        console.error("Error updating category:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.error,
        });
      });
  };


  return (
    <div className="p-3">
      <h2>Edit Sub Category</h2>
      <form onSubmit={handleSave} className="category" style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
        <div className="category-field">
          <div className="d-flex">
            <label className="fs-6 fw-bold">Category Name:</label>
            <br />
            <p className="mx-2">{categories}</p>
          </div>

          <label htmlFor="name" className="fs-6 fw-bold">
            Change Sub Category Name:
          </label>
          <br />
          <input
            type="text"
            id="name"
            value={newSubCategoryName}
            onChange={(e) => setNewSubCategoryName(e.target?.value)}
          />
        </div>
        <div className="buttons">
          <button type="submit" style={{ backgroundColor: "#0443C0", color: "white" }}>Save</button>
          <button style={{ backgroundColor: "#F04B25", color: "white" }}>Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default EditSubCategory;
